<div class="modal-header">
    <div
        class="modal-title h4"
        role="heading"
        aria-level="1"
    >
        {{ i18n._927_CONTINUE_YOUR_SESSION | translate }}
    </div>
    <button
        type="button"
        class="close"
        [attr.aria-label]="i18n._763_CLOSE | translate"
        (click)="activeModal.dismiss('dismiss')"
    >
        <cmps-icon svgIcon="close"></cmps-icon>
    </button>
</div>
<div class="modal-body">
    <cmps-auth-login [isReAuth]="true"></cmps-auth-login>
</div>
